export default __webpack_public_path__ + "static/media/img3.81ea9096.png";